export default __webpack_public_path__ + "static/media/game2.d6c5fad7.webp";